import { Navigate, Route, Routes } from 'react-router'
import { observer } from 'mobx-react-lite'
import { AllWorkflows, WorkflowView } from 'pages/hubspotWorkflows/pages'
import {
  HubspotWorkflowsAccessLayout,
  HubspotWorkflowsPageLayout,
  HubspotWorkflowViewAccessLayout,
} from 'pages/hubspotWorkflows/layout'
import { HubspotWorkflowsRoutes } from './type'
import { HubspotWorkflowsPath } from './hubspotWorkflowsPath'

export const HubspotWorkflowsRouter = observer(() => {
  return (
    <Routes>
      <Route element={<HubspotWorkflowsAccessLayout />}>
        <Route element={<HubspotWorkflowsPageLayout />}>
          <Route path={'/'} element={<AllWorkflows />} />
          <Route element={<HubspotWorkflowViewAccessLayout />}>
            <Route path={`${HubspotWorkflowsRoutes.view}/:id`} element={<WorkflowView />} />
          </Route>
          <Route path={'*'} element={<Navigate to={`/${HubspotWorkflowsPath.root}`} replace />} />
        </Route>
      </Route>
    </Routes>
  )
})
